export default `
  <div class="wb-doc-page">
    <div class="doc-text doc-pt16 doc-pb28">1. 倘若客户要求并授权盈宝证券国际（香港）有限公司（「盈宝证券」）作为其代理人及为客户或其他任何人士的利益申请于联交所新上市和/或新发行的证券，为了盈宝证券的利益，客户保证在该等申请作出时盈宝证券有权代表客户作出该等申请。 </div>

    <div class="doc-text doc-pb28">2. 客户应熟悉并遵从任何招股说明书及/或发行文件、申请表格或其他有关文件内所载之管辖新上市及/或发行证券及其申请之全部条款及细则，客户同意在与盈宝证券进行的任何交易中受该等条款及细则约束。 </div>

    <div class="doc-text doc-pb28">3. 客户向盈宝证券作出新上市及/或发行证券申请人（不论是向有关证券的发行人、保荐人、承销人或配售代理人、联交所或任何其他相关监管机构或人士）需要作出的所有声明、保证和承诺。 </div>

    <div class="doc-text doc-pb28">4. 客户声明及保证，并授权盈宝证券通过任何申请表格（或以其他方式）向联交所和任何其他适合人士披露及保证，为受益予客户或客户在申请中载明的受益人士，盈宝证券作为客户代理人作出的任何申请是客户或盈宝证券代表客户作出唯一的申请或打算作出的唯一申请。客户确认并接受，就盈宝证券作为客户代理人作出的任何申请而言，盈宝证券和有关证券的发行人、保荐人、承销人或配售代理人、联交所或任何其他相关监管机构或人士会依赖上述声明及保证。 </div>

    <div class="doc-text doc-pb28">5. 客户声明及保证，客户是一个合资格根据招股说明书及/或发行文件及申请表格或任何其他有关此新上市及/或发行证券文件申请于联交所新上市及/或新发行的证券的人士，及明白盈宝证券将会倚赖此声明及保证。 </div>

    <div class="doc-text doc-pb28">6. 客户承认并明白，证券申请的法律和监管规定及市场惯例不时变化，而任何一种新上市或新发行证券的规定亦会变更。客户承诺会按盈宝证券不时绝对酌情权决定的法律和监管规定及市场惯例的要求，向盈宝证券提供资料并采取额外的步骤和作出额外的声明、保证和承诺。 </div>

    <div class="doc-text doc-pb16">7. 有关盈宝证券或其代理人为盈宝证券本身及/或客户及/或为盈宝证券之其他客户进行大额申请时，客户确认并同意：</div>
    <div class="doc-text doc-pb16">(i) 该大额申请可能会因与客户及客户申请无关的理由而被拒绝，而在没有欺诈、疏忽和故意违约的情况下，盈宝证券和其代理人无须就该拒绝对客户或任何其他人士负上责任；及</div>
    <div class="doc-text doc-pb28">(ii) 倘若该大额申请因声明和保证被违反或任何与客户有关的理由而被拒绝，客户需向盈宝证券作出赔偿。客户确认，客户亦会对其他受上述违反或其他理由影响的人士的损失负上责任。 </div>

    <div class="doc-text doc-pb28">8. 盈宝证券在收到客户要求申请新股股票时，盈宝证券可向客户提供该新股融资。由于就该新股融资或其他事项为客户欠付到期及须即时缴付之所有本金、利息、及其他款项（「有抵押负债」）作出之持续性担保，客户作为实益拥有人以第一固定抵押形式向盈宝证券抵押新股股票，直至客户向盈宝证券全数付清有抵押新股融资; 客户兹此表明授权盈宝证券就受抵押股票之任何部份收取及运用盈宝证券收到之所有金额，不论该金额之性质，并以盈宝证券全权决定之方式及时间支付有抵押负债。 </div>

    <div class="doc-text doc-pb28">9. 如有新股延迟或取消上市的情况，盈宝证券不会就客户因该等情况而直接或间接产生的任何损失或支出承担任何的责任。 </div>
    
    <div class="doc-text doc-pb16">10. IPO融资申购风险提示: </div>
    <div class="doc-text doc-pb16">(i) IPO融资申购具有高杠杆风险。在上市当日，可能增加帐户的潜在风险。中签用户需确保帐户内有足够的自有资金，否则在上市当日，若发生保证金追缴，盈宝证券有权在特定情况下卖出客户部分或全部股票。因保证金追缴导致盈宝证券卖出客户股票所造成的投资损失，须由客户自行承担。</div>
    <div class="doc-text doc-pb16">11. 使用货币基金抵押打新提示信息: </div>
    <div class="doc-text doc-pb16">(i) 请注意，货币基金并非等同于现金，其赎回款项可能因处理流程存在延迟，无法在新股申购截止限期前顺利到账。若因此导致您无法按要求支付预付认购资金，进而造成新股申购失败，相关风险与责任将由客户自行承担。</div>
    <div class="doc-text doc-pb16">(ii) 此外，若货币基金赎回款未能及时到账，而盈宝证券为客户垫付 10% 的预付认购资金（注：盈宝证券并非必然提供垫付服务），客户需根据规定支付相应的利息费用。 </div>
    <div class="doc-text doc-pb16">(iii) 为避免产生额外成本或影响新股申购计划，请您务必提前做好资金安排，仔细阅读并了解相关业务规则，充分认知潜在的费用与风险，确保申购流程顺利进行。 </div>
    </div>
`
